import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function OptOut() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const e = params.get("email");
    if (e) setEmail(e);
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/opt-out", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-24" data-testid="optout-page">
      <div className="text-center mb-8">
        <ShieldCheck size={36} className="text-gold mx-auto mb-4" />
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-100">OPT OUT OF INVITATIONS</h1>
        <p className="text-sm text-slate-500 mt-3 leading-relaxed">
          10XGLOBAL only contacts role-based public business addresses published on a company's own official website. Enter your email and we will never contact it again — instantly and permanently.
        </p>
      </div>
      {done ? (
        <div className="card-surface hairline-gold p-7 text-center" data-testid="optout-success">
          <p className="text-gold font-display font-bold">You're opted out.</p>
          <p className="text-sm text-slate-400 mt-2">{email} has been added to our permanent suppression list. No further invitations will be sent.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="card-surface p-7 space-y-4" data-testid="optout-form">
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-1.5">Business Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com" data-testid="optout-email-input" className="input-dark" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="optout-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="optout-submit-btn" className="btn-gold w-full disabled:opacity-60">
            {loading ? <><Loader2 size={15} className="animate-spin" /> PROCESSING…</> : "OPT OUT PERMANENTLY"}
          </button>
        </form>
      )}
    </div>
  );
}
